import { Callout as BlueprintCallout, CalloutProps as BlueprintCalloutProps } from '@blueprintjs/core';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import styles from './Callout.module.css';

type CalloutProps = Pick<BlueprintCalloutProps, 'title' | 'intent' | 'className' | 'icon'>;

export function Callout({ intent, title, className, icon, children }: PropsWithChildren<CalloutProps>) {
    const combinedClassNames = classNames(styles.callout, className);
    return (
        <BlueprintCallout intent={intent} title={title} icon={icon} className={combinedClassNames}>
            {children}
        </BlueprintCallout>
    );
}
